import { Link } from 'react-router-dom'

const NAV_LINKS = [
  { to: '/',          label: 'Üzleti lehetőség' },
  { to: '/rolam',     label: 'Rólam' },
  { to: '/5in1',      label: 'Termékek – 5in1' },
  { to: '/kapcsolat', label: 'Kapcsolat' },
]

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-border/6 py-14 px-6 bg-surface">
      <div className="max-w-6xl mx-auto">

        <div className="grid sm:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <p className="font-display text-xl text-heading mb-2">
              Rose <span className="text-orange-500">Gold Team</span>
            </p>
            <p className="text-sm text-muted-text leading-relaxed max-w-xs">
              Független LR Health &amp; Beauty partner csapat. Prémium termékek és üzleti lehetőség.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs font-bold tracking-widest uppercase text-subtle-text mb-3">Navigáció</p>
            <nav className="flex flex-col gap-2">
              {NAV_LINKS.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  className="text-sm text-muted-text hover:text-gold transition-colors"
                >
                  {label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Legal */}
          <div>
            <p className="text-xs font-bold tracking-widest uppercase text-subtle-text mb-3">Jogi</p>
            <nav className="flex flex-col gap-2">
              <Link to="/adatkezeles" className="text-sm text-muted-text hover:text-gold transition-colors">
                Adatkezelési tájékoztató
              </Link>
              <Link to="/aszf" className="text-sm text-muted-text hover:text-gold transition-colors">
                ÁSZF
              </Link>
              <button
                onClick={() => { localStorage.removeItem('lr-cookie-consent'); window.location.reload() }}
                className="text-sm text-muted-text hover:text-gold transition-colors text-left"
              >
                Cookie beállítások
              </button>
            </nav>
          </div>
        </div>

        <div className="divider-gold mb-8" />

        {/* Legal */}
        <div className="space-y-3 text-xs text-subtle-text leading-relaxed">
          <p>
            <strong className="text-muted-text">Jogi nyilatkozat:</strong>{' '}
            A Rose Gold Team egy független LR Health &amp; Beauty partner csapat promóciós weboldala,
            és nem az LR Health &amp; Beauty GmbH hivatalos weboldala.
          </p>
          <p>
            <strong className="text-muted-text">Egészségügyi nyilatkozat:</strong>{' '}
            Az ezen az oldalon szereplő információk kizárólag tájékoztató jellegűek,
            és nem minősülnek orvosi tanácsnak. Betegség esetén kérje ki orvos véleményét.
          </p>
          <p>
            <strong className="text-muted-text">Adatvédelem:</strong>{' '}
            A megadott személyes adatokat GDPR-kompatibilis módon kezeljük.{' '}
            Részletek:{' '}
            <Link to="/adatkezeles" className="text-gold/80 hover:text-gold underline underline-offset-2 transition-colors">
              Adatkezelési tájékoztató
            </Link>{' '}
            ·{' '}
            <Link to="/aszf" className="text-gold/80 hover:text-gold underline underline-offset-2 transition-colors">
              ÁSZF
            </Link>
          </p>
          <p className="pt-2 text-subtle-text/50">
            &copy; {year} Rose Gold Team · Minden jog fenntartva
          </p>
        </div>

      </div>
    </footer>
  )
}
